var styles = {
  "BottomSheet": "Online-Store-UI-BottomSheet_oh35g",
  "isModal": "Online-Store-UI-BottomSheet--isModal_1eymt",
  "expanded": "Online-Store-UI-BottomSheet--expanded_uem4b",
  "BottomSheetInterior": "Online-Store-UI-BottomSheet__BottomSheetInterior_14010",
  "paddingExtraTight": "Online-Store-UI-BottomSheet--paddingExtraTight_1t2wj",
  "paddingTight": "Online-Store-UI-BottomSheet--paddingTight_17aes",
  "paddingBaseTight": "Online-Store-UI-BottomSheet--paddingBaseTight_160x3",
  "paddingBase": "Online-Store-UI-BottomSheet--paddingBase_ry84w",
  "paddingLoose": "Online-Store-UI-BottomSheet--paddingLoose_1yuqv",
  "paddingExtraLoose": "Online-Store-UI-BottomSheet--paddingExtraLoose_1q1dk"
};

export { styles as default };
